import { Steps } from "antd";
import React, { useEffect, useState } from "react";
import { StaffUser } from "../../../generated";
import { SaveAssignment } from "./save-assignment";
import { CaseState } from "../../../constants";
import { Tags } from "../tags";

const { Step } = Steps;

export interface CaseDetailsProps {
  staffInfo: StaffUser[];
  currentStaff: StaffUser | undefined;
  assignedWorkerInfo: StaffUser | undefined;
  onSave: (values: StaffUser | null) => void;
  data: {
    caseData: {
      id: string;
      state: string;
      requestedAt: Date;
      revisionSubmittedAt: Date;
      tags: (string | null)[] | []
    };
  };
  onTagsChange: (newTags: string[]) => Promise<boolean>;
  isCurrentUser: boolean;
}

const stepArray = ["draft", "submitted", "caseWorkerAssigned", "revisionRequested", "revisionSubmitted", "decisionRendered"];

export const CaseDetails: React.FC<CaseDetailsProps> = (props) => {
  const { caseData } = props.data || {};

  const currentStep = stepArray.findIndex((value) => value === caseData?.state);
  const [selectedStaff, setSelectedStaff] = useState<StaffUser | undefined>(props.assignedWorkerInfo);

  useEffect(() => {
    // Update the selected staff when assignedWorkerInfo changes
    setSelectedStaff(props.assignedWorkerInfo);
  }, [props.assignedWorkerInfo, props.data, caseData.state]);

  const canAssignStaff = [
    CaseState.SUBMITTED,
    CaseState.CASE_WORKER_ASSIGNED,
    CaseState.REVISION_REQUESTED,
    CaseState.REVISION_SUBMITTED,
    CaseState.DECISION_RENDERED,
  ].includes(caseData.state);

  const canModifyTags = [
    CaseState.SUBMITTED,
    CaseState.CASE_WORKER_ASSIGNED,
    CaseState.REVISION_REQUESTED,
    CaseState.REVISION_SUBMITTED,
    CaseState.DRAFT,
  ].includes(caseData.state);

  const handleSave = (values: StaffUser | null) => {
    props.onSave(values);
  };

  const renderSteps = () => {
    const steps = [
      <Step key="draft" title="Draft" />,
      <Step key="submitted" title="Submitted" />,
      <Step key="caseWorkerAssigned" title="Assigned" />,
      <Step key="revisionRequested" title="Revision Requested" />,
      <Step key="revisionSubmitted" title="Revision Submitted" />
    ];

    steps.push(<Step key="decisionRendered" title="Decision Rendered" />);


    return steps;
  };

  return (
    <>
      {canAssignStaff && props.staffInfo.length > 0 && (
        <SaveAssignment
          caseStatus={caseData.state}
          staffInfo={props.staffInfo}
          currentStaff={props.currentStaff}
          selectedStaff={selectedStaff}
          onSave={handleSave}
          handleStaffSelection={(value) => {
            const staff = props.staffInfo.find((staff) => staff.id === value);
            setSelectedStaff(staff);
          }}
        />
      )}
      <div style={{marginBottom: 15, marginLeft: 15}}><Tags readonly={canModifyTags === false} tagsData={props.data.caseData.tags} onTagsChange={props.onTagsChange}/></div>

      <div className="float-left custom-steps" style={{width: "100%"}} >
        <Steps current={currentStep} percent={(currentStep / (renderSteps().length - 1)) * 100} size="small">
          {renderSteps()}
        </Steps>
      </div>
    </>
  );
};